import {
  GET_SUGGEST_SLOT,
  GET_SUGGEST_SLOT_SUCCESS,
  GET_SUGGEST_SLOT_FAILURE,
} from 'store/getSuggestSlot/getSuggestSlotAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSuggestSlotDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUGGEST_SLOT:
      return { ...state, loading: true };
    case GET_SUGGEST_SLOT_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SUGGEST_SLOT_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSuggestSlotDataReducer;
